import React from 'react';
import SubHeader from '../../SubHeader.jsx';

const MultistepCombinedHeader = ({
  children,
  subject,
  typeStep,
  editing,
  onDelete,
}) => {
  return (
    <React.Fragment>
      {children}

      <SubHeader flexJustify small>
        <h2>
          {editing ? 'Edit' : 'Add'} {subject}: {typeStep}
        </h2>

        <div className="flex">
          {editing && onDelete ? (
            <button type="button" className="btn btn-danger" onClick={onDelete}>
              Delete
            </button>
          ) : null}
        </div>
      </SubHeader>
    </React.Fragment>
  );
};

export default MultistepCombinedHeader;
